import { HeaderBase } from "../../shared/HeaderBase";
import logo from "../images/seaside-logo.png";

export const Header = () => (
  <HeaderBase
    brand={
      <img
        src={logo}
        style={{
          height: 99,
          width: 86,
        }}
        alt="Seaside No.1"
      />
    }
  />
);
